
'use strict';

var $ = require('jquery'),
  _ = require('underscore'),
  ApplicationTabsView = require('./ApplicationTabsView'),
  $global = require('../globalElements'),
  Backbone = require('backbone');

Backbone.$ = $;

var BrowseView = Backbone.View.extend({

  showCountClassName: 'u-showCount-',
  defaultFilter: 'all',

  initialize: function() {
    this.currentFilter = null;

    var filterRegex = new RegExp('(^|\\s)' + this.showCountClassName + '\\S+', 'g'),
      filterClassnameMatch = this.el.className.match(filterRegex);

    if (filterClassnameMatch && filterClassnameMatch.length) {
      // Get the filter name from HTML classname
      this.currentFilter = filterClassnameMatch[0].substring(this.showCountClassName.length + 1);
    } else {
      // Switch to a default filter if no filter is set
      this.switchFilter(this.defaultFilter);
    }

    var ReferenceDesignTabView = this.$('.js-referenceDesigns-drawer');
    _.each(ReferenceDesignTabView, function(element) {
      new ApplicationTabsView({
        el: element
      });
    });

  },

  // Switch between tabs
  switchTab: function(categoryType) {
    this.$('.ReferenceDesign-browseTab.is-active').removeClass('is-active');
    this.$('.ReferenceDesign-browseTab[data-category-type=' + categoryType + ']').addClass('is-active');
    $global.$window.trigger('scroll'); // this is used to trigger the lazy loading for of lazy load
  },

  // Switch between design type counts
  switchFilter: function(filter) {
    this.$el.removeClass(this.showCountClassName + this.currentFilter).addClass(this.showCountClassName + filter);
    this.currentFilter = filter;
  }
});

module.exports = BrowseView;



// WEBPACK FOOTER //
// ./assets/js/reference/BrowseView.js